export var EField;
(function (EField) {
    EField["Captcha"] = "captcha";
    EField["Password"] = "password";
    EField["PhoneOrEmail"] = "phoneOrEmail";
})(EField || (EField = {}));
